<template>
  <div>
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody bodyHeader" :label="$t('Inicio')">
        <h2 class="txt-bienvenida">Bienvenido {{ username }}</h2>
        <p class="font-gray">
          Para continuar debe seleccionar el rol con el cúal desea acceder a la plataforma Inventario de Riesgos HSE
          Online,
          abajo visualizará el formulario de ingreso en el que debe seleccionar la siguiente información: Faena, Tipo de
          usuario, Área y el rol.
          una ver realizado ésto podrá visualizar el botón "Continuar", con éste podrá ingresar a su Dashboard Personal.
        </p>
        <br />
        <center v-if="loading">
          <br />
          <br />
          <Circle9 style="margin-bottom: 8px;"></Circle9>
          <small>Cargando Datos ...</small>
          <br />
          <br />
        </center>
        <div v-else>
          <el-card>
            <div slot="header" class="clearfix">
              <b>
                <span class="font-gray">Para continuar seleccione el rol que desea utilizar en la plataforma</span>
              </b>
            </div>
            <el-form label-position="top" :inline="true" onsubmit="return false;">
              <el-form-item label="Seleccione Faena">
                <el-select @change="getRoles" class="widthFaena" v-model="faena_selected"
                  placeholder="Seleccione una Faena">
                  <el-option v-for="item in $store.getters.roles ? $store.getters.roles : []" :key="item._id"
                    :label="getFaena(item.faena_id)" :value="item.faena_id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Seleccione Tipo de Usuario" v-if="data_roles">
                <el-select @change="resetSelection()" class="widthFaena" v-model="type_user"
                  placeholder="Seleccione tipo de usuario">
                  <el-option v-for="(item, i) in data_roles.type" :key="i" :label="roles[item]"
                    :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Seleccione Área" v-if="type_user && type_user === 'propio'">
                <el-select @change="resetRole()" class="widthFaena" v-model="area_selected"
                  placeholder="Seleccione un área">
                  <el-option v-for="(item, i) in data_roles.areas" :key="i" :label="item.nombre"
                    :value="item._id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Seleccione Empresa" v-if="type_user && type_user === 'contratista'">
                <el-select @change="resetRole()" class="widthFaena" v-model="empresa_selected"
                  placeholder="Seleccione una empresa">
                  <el-option v-for="(item, i) in data_roles.empresas" :key="i" :label="item.nombre"
                    :value="item._id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Seleccione Rol" v-if="area_selected && type_user === 'propio'">
                <el-select class="widthFaena" v-model="rol_selected" placeholder="Seleccione un rol">
                  <el-option v-for="(item, i) in data_roles.all_roles.propio" :key="i"
                    v-if="validar(item, area_selected)" :label="reviewerRoles[item]" :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Seleccione Rol" v-if="empresa_selected && type_user === 'contratista'">
                <el-select class="widthFaena" v-model="rol_selected" placeholder="Seleccione un rol">
                  <el-option v-for="(item, i) in data_roles.all_roles.contratista" :key="i"
                    v-if="validar(item, empresa_selected)" :label="reviewerRoles[item]" :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="(rol_selected && rol_selected !== 'admin') || type_user === 'superadmin'">
                <br />
                <el-button type="primary" @click="next()">
                  Continuar
                  <i class="el-icon-arrow-right"></i>
                </el-button>
              </el-form-item>
            </el-form>
          </el-card>
          <br />
          <br />
          <center>
            <el-button v-if="type_user" @click="dialogTable = true" type="info">Visualizar Tabla de Roles</el-button>
          </center>

          <el-dialog title="Visualizando Tabla de Roles" :visible.sync="dialogTable" width="70%"
            :before-close="handleClose">
            <br />
            <!-- TABLA CONTRATISTA -->
            <table v-if="type_user === 'contratista' && data_roles">
              <tr>
                <td></td>
                <td class="cell header-table" :colspan="data_roles.all_roles.contratista.length">Roles</td>
              </tr>
              <tr>
                <td class="cell sub-header-table">Empresas</td>
                <td class="cell sub-header-table" v-for="(item, i) in data_roles.all_roles.contratista" :key="i">
                  {{ reviewerRoles[item] }}</td>
              </tr>
              <tr v-for="(empresa, i) in data_roles.empresas" :key="i">
                <td class="cell">{{ empresa.nombre }}</td>
                <td @click="setData(empresa._id, rol)" class="cell" v-if="validar(rol, empresa._id)"
                  :class="{ selectionCell: validar(rol, empresa._id), cellOrange: validar(rol, empresa._id) }"
                  v-for="(rol, i) in data_roles.all_roles.contratista" :key="i">
                  <center>
                    <i style="font-size: 15px;" class="el-icon-check"></i>
                  </center>
                </td>
                <td v-else class="cell cellGray centrar">
                  <i style="font-size: 15px;" class="el-icon-close"></i>
                </td>
              </tr>
            </table>
            <!-- TABLA PROPIOS -->
            <table v-if="type_user === 'propio' && data_roles">
              <tr>
                <td></td>
                <td class="cell header-table" :colspan="data_roles.all_roles.propio.length">Roles</td>
              </tr>
              <tr>
                <td class="cell sub-header-table">Áreas</td>
                <td class="cell sub-header-table" v-for="(item, i) in data_roles.all_roles.propio" :key="i">
                  {{ reviewerRoles[item] }}</td>
              </tr>
              <tr v-for="(area, i) in data_roles.areas" :key="i">
                <td class="cell">{{ area.nombre }}</td>
                <td @click="setData(area._id, rol)" class="cell"
                  :class="{ selectionCell: validar(rol, area._id), cellOrange: validar(rol, area._id), cellGray: !validar(rol, area._id) }"
                  v-for="(rol, i) in data_roles.all_roles.propio" :key="i">
                  <center>
                    <i style="font-size: 15px;" v-if="validar(rol, area._id)" class="el-icon-check"></i>
                    <i style="font-size: 15px;" v-if="!validar(rol, area._id)" class="el-icon-close"></i>
                  </center>
                </td>
              </tr>
            </table>
            <!-- TABLA SUPERADMIN -->
            <table v-if="type_user === 'superadmin' && data_roles">
              <tr>
                <td></td>
                <td class="cell header-table" :colspan="data_roles.all_roles.propio.length">Roles</td>
              </tr>
              <tr>
                <td class="cell sub-header-table">Faena</td>
                <td class="cell sub-header-table">Administrador del sistema</td>
              </tr>
              <tr>
                <td class="cell">{{ getFaena(faena_selected) }}</td>
                <td @click="setData(null, 'admin')" class="cell selectionCell cellOrange">
                  <center>
                    <i style="font-size: 15px;" class="el-icon-check"></i>
                  </center>
                </td>
              </tr>
            </table>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="dialogTable = false">Cancelar</el-button>
            </span>
          </el-dialog>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import axios from "axios";
import { Circle9 } from "vue-loading-spinner";

export default {
  name: "SelectRoles",
  data() {
    return {
      dialogTable: false,
      empresa_selected: "",
      rol_selected: "",
      area_selected: "",
      roles: {
        propio: "Usuario BHP",
        contratista: "Usuario Contratista",
        superadmin: "Administrador de Plataforma",
      },
      faena_selected: "",
      type_user: "",
      data_roles: null,
      reviewerRoles: {
        health: "Especialista Salud",
        safety: "Especialista Seguridad",
        environment: "Especialista Medioambiente",
        contractor_coordinator: "Coordinador Contratista",
        coordinator: "Coordinador",
        contractor_hse: "HSE Contratista",
        contract_owner: "Dueño de Contrato",
        administrator: "Administrador de Contrato",
        hse: "HSE",
        owner: "Dueño de Contrato",
        risk: "Especialista de Riesgo",
        manager: "Gerente",
        super: "Superintendente",
        general_manager: "Gerente General",
      },
      loading: false,
    };
  },
  computed: {
    username() {
      return this.$store.getters.user ? `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}` : "---";
    },
    faenas() {
      return this.roles.map((r) => r.faena_id);
    },
  },
  async created() {
    this.$store.dispatch(
      "setSubTitle",
      this.$t("Selección de Rol")
    );
    if (!this.$store.getters.latest_state) {
      this.faena_selected = this.$store.getters.roles[0].faena_id;
      this.getRoles(this.faena_selected);
    } else {
      this.faena_selected = this.$store.getters.latest_state.faena_selected;
      await this.getRoles(this.faena_selected, true);
      this.type_user = this.$store.getters.latest_state.type_user;
      this.empresa_selected = this.$store.getters.latest_state.empresa_selected;
      this.rol_selected = this.$store.getters.latest_state.rol_selected;
      this.area_selected = this.$store.getters.latest_state.area_selected;
    }
    await this.$store.dispatch("getFaenas");
  },
  components: {
    Circle9
  },
  methods: {
    handleClose() {
      this.dialogTable = false;
    },
    resetRole() {
      this.rol_selected = "";
    },
    resetSelection() {
      this.area_selected = "";
      this.empresa_selected = "";
      this.rol_selected = "";
    },
    next() {
      if (this.type_user === "contratista") {
        this.setData(this.empresa_selected, this.rol_selected);
      }
      if (this.type_user === "propio") {
        this.setData(this.area_selected, this.rol_selected);
      }
      if (this.type_user === "superadmin") {
        this.setData(null, "admin");
      }
    },
    validar(rol, id) {
      if (this.type_user === "contratista") {
        if (
          this.data_roles.empresas[id] &&
          this.data_roles.empresas[id].roles.includes(rol)
        ) {
          return true;
        }
        return false;
      }
      if (this.type_user === "propio") {
        if (
          this.data_roles.areas[id] &&
          this.data_roles.areas[id].roles.includes(rol)
        ) {
          return true;
        }
        return false;
      }
    },
    async getRoles(faena, clear_type_user) {
      // this.loading = true;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      let response = await axios.get(
        `/inventarios/getRoles/${this.$store.getters.user._id}/${faena}`, config
      );

      this.data_roles = response.data;
      if (clear_type_user !== true) {
        this.type_user = "";
      }
      this.loading = false;
    },
    getFaena(faena_id) {
      const faena = this.$store.getters.faenas.find((x) => x._id === faena_id);
      if (faena && faena.nombre) {
        return faena.nombre;
      }
    },
    async setData(id, role) {
      this.rol_selected = role;
      const newRole = {
        faena_id: this.faena_selected,
      };
      // Empresa
      if (this.type_user === "contratista") {
        newRole.empresa_id = id;
        this.empresa_selected = id;
      }
      if (this.type_user === "propio") {
        newRole.area_id = id;
        this.area_selected = id;
      }
      if (this.type_user === "superadmin") {
        newRole.admin = true;
      }
      // Role
      newRole.role = role;
      // ultimo estado
      const latest_state = {
        faena_selected: this.faena_selected,
        type_user: this.type_user,
        empresa_selected: this.empresa_selected,
        rol_selected: this.rol_selected,
        area_selected: this.area_selected,
      };
      // reset datos de otros roles
      await this.$store.dispatch("updateData");
      await this.$store.dispatch("resetEmpresasFaena");
      await this.$store.dispatch("resetAreas");
      await this.$store.dispatch("resetContract");
      await this.$store.dispatch("resetUserContractByRole");
      await this.$store.dispatch("latestState", latest_state);
      await this.$store.dispatch("setRole", newRole);
      await this.$store.dispatch("setAllRiesgosPendientes", null);
      if (this.$route.name === "SelectRoles") {
        this.$router.push({ name: "dashboardPersonal" });
      } else {
        this.$router.push({ name: "homePage" });
      }
    },
  },
};
</script>

<style scoped>
.txt-bienvenida {
  font-size: 30px;
  margin-bottom: 0px;
}

.font-gray {
  color: gray;
}

.widthFaena {
  width: 330px;
}

.margin-left-form {
  margin-left: 50px;
}

.centrar {
  text-align: center;
}

.cellGray {
  background-color: white;
}

.cellOrange {
  background-color: rgb(253, 162, 105);
  color: white;
}

.header-table {
  font-size: 17px !important;
  color: white;
  background-color: #242424;
  font-weight: bold;
  text-align: center;
}

.sub-header-table {
  color: white;
  background-color: #242424;
  font-weight: bold;
  text-align: center;
}

table {
  border-collapse: collapse;
  overflow-x: scroll;
  margin: 0 auto;
}

thead,
tbody {
  display: block;
}

tbody {
  overflow: auto;
  max-height: 500px;
}

.cell {
  min-width: 100px;
  height: 15px;
  overflow: hidden;
  padding: 10px;
  border: 1px solid rgb(197, 197, 197);
  font-size: 15px;
}

.selectionCell:hover {
  background-color: #f67b2f;
  cursor: pointer;
}

.widthTd {
  width: 560px;
}

.bodyHeader {
  min-height: 300px;
}

.font-small {
  font-size: 15px;
}
</style>
